// extracted by mini-css-extract-plugin
export default {"container":"Search_container__h7iZT","input":"Search_input__wQVw5","icon":"Search_icon__pwPp9"};